import { Menu } from "@fluentui/react-northstar";
import * as React from "react";
import { useCallback } from "react";
import { NotificationSeveritySelection } from "../../../model";

interface Props {
    onSelectionChange: (selection: NotificationSeveritySelection) => void
}
const NotificationSeveritySelector: React.FC<Props> = ({onSelectionChange}) => {

    const handleMenuClicked = useCallback((event: React.SyntheticEvent<HTMLElement>, data?: any) => {
        const newSelection = data!.name as NotificationSeveritySelection
        onSelectionChange(newSelection)
    }, [onSelectionChange])

    const items = [
        {
            key: 'errors',
            name: 'errors',
            content: 'Errors',
            onClick: handleMenuClicked
        },
        {
            key: 'warnings',
            name: 'warnings',
            content: 'Warnings',
            onClick: handleMenuClicked
        },
        {
            key: 'information',
            name: 'information',
            content: 'Information',
            onClick: handleMenuClicked
        },
        {
            key: 'all',
            name: 'all',
            content: 'All',
            onClick: handleMenuClicked
        },
    ]

    return <Menu defaultActiveIndex={3} items={items} primary />
}

export default NotificationSeveritySelector;